
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4NZXC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd448e886e02e1982ace165a769cbc67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37fbcd1eaffadc0f$var$_react = $37fbcd1eaffadc0f$var$_interopRequireDefault((parcelRequire("42omo")));

var $37fbcd1eaffadc0f$var$_baseNew = $37fbcd1eaffadc0f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $37fbcd1eaffadc0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/tasks
 * Usage guidance:
 * Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37fbcd1eaffadc0f$var$TasksIcon = (props)=>/*#__PURE__*/ $37fbcd1eaffadc0f$var$_react.default.createElement($37fbcd1eaffadc0f$var$_baseNew.default, Object.assign({
        name: "TasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm6.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L6 8.086z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$37fbcd1eaffadc0f$var$TasksIcon.displayName = 'TasksIcon';
var $37fbcd1eaffadc0f$var$_default = module.exports.default = $37fbcd1eaffadc0f$var$TasksIcon;

});


//# sourceMappingURL=tasks.4e573bd1.js.map
